<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function initializeProductVideos() {
  const videos = document.querySelectorAll('.product-block__video');
  videos.forEach(video => {
    video.muted = true;
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductVideos, { once: true });
} else {
  initializeProductVideos();
}

(function () {
  let articleTocCleanup = null;

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  }

  function buildArticleToc() {
    if (articleTocCleanup) {
      articleTocCleanup();
      articleTocCleanup = null;
    }

    const article = document.querySelector('.template-article .article-template');
    if (!article) return;

    const pageContent = article.querySelector('.halo-article-block .page-content');
    const articleContent = article.querySelector('.article-content');
    if (!pageContent || !articleContent) return;

    const existingToc = pageContent.querySelector('.pa-article-toc');
    if (existingToc) existingToc.remove();

    const headings = Array.from(articleContent.querySelectorAll('h2'))
      .filter(heading => heading.textContent.trim().length > 0);

    if (headings.length < 2) return;

    const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map(element => element.id));

    headings.forEach((heading, index) => {
      if (heading.id) return;

      const baseId = `article-${slugify(heading.textContent)}-${index + 1}`;
      let id = baseId;
      let suffix = 2;

      while (usedIds.has(id)) {
        id = `${baseId}-${suffix}`;
        suffix += 1;
      }

      heading.id = id;
      usedIds.add(id);
    });

    const toc = document.createElement('aside');
    toc.className = 'pa-article-toc';
    toc.setAttribute('aria-label', 'Article contents');

    const inner = document.createElement('div');
    inner.className = 'pa-article-toc__inner';

    const title = document.createElement('p');
    title.className = 'pa-article-toc__title';
    title.textContent = 'In this article';

    const list = document.createElement('ol');
    list.className = 'pa-article-toc__list';

    const links = headings.map(heading => {
      const item = document.createElement('li');
      item.className = 'pa-article-toc__item';

      const link = document.createElement('a');
      link.className = 'pa-article-toc__link';
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();

      link.addEventListener('click', event => {
        event.preventDefault();
        const offset = 120;
        const top = heading.getBoundingClientRect().top + window.scrollY - offset;

        window.history.replaceState(null, '', `#${heading.id}`);
        window.scrollTo({ top, behavior: 'smooth' });
      });

      item.appendChild(link);
      list.appendChild(item);

      return link;
    });

    inner.appendChild(title);
    inner.appendChild(list);
    toc.appendChild(inner);
    pageContent.appendChild(toc);

    function setActiveLink() {
      const anchorLine = window.scrollY + 150;
      let activeHeading = headings[0];

      headings.forEach(heading => {
        const headingTop = heading.getBoundingClientRect().top + window.scrollY;
        if (headingTop <= anchorLine) activeHeading = heading;
      });

      links.forEach(link => {
        const isActive = link.getAttribute('href') === `#${activeHeading.id}`;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;

      window.requestAnimationFrame(() => {
        setActiveLink();
        ticking = false;
      });
      ticking = true;
    };

    const handleResize = () => setActiveLink();

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize);
    articleTocCleanup = () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
    setActiveLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildArticleToc);
  } else {
    buildArticleToc();
  }

  document.addEventListener('shopify:section:load', buildArticleToc);
})();
